module.exports = __webpack_public_path__ + "Administer_Example-4506355507edad2f9113e7a98a6d631c.png";